import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert'
import ProtectedContent from 'app/frontend/base/components/ProtectedContent'
import { useTeam } from 'app/frontend/base/config/context/team'
import { t } from 'i18next'
import { useState } from 'react'
import AddMemberModal from '../../TeamRoster/components/AddMemberModal'
import { Button } from '@/components/ui/button'
import { useAuth } from 'app/frontend/base/config/context/auth'
import { Link } from 'react-router-dom'

type Props = {
  className?: string
}

const NoMemberWarning = ({ className }: Props) => {
  const { team } = useTeam()
  const { accessLevel } = useAuth()
  const [addingMembers, setAddingMembers] = useState(false)

  return (
    <Alert className={className}>
      <AlertTitle>No members found</AlertTitle>
      <AlertDescription>
        <p className='mb-4'>
          {(team.members ?? []).length > 0 ? (
            <span>
              No members in your team are visible in the loot section.{' '}
              {accessLevel !== 'admin' ? (
                ''
              ) : (
                <span>
                  Visit the{' '}
                  <Link
                    to={`${team.path}/settings#roster`}
                    className='text-primary hover:text-primary/90'
                  >
                    roster settings
                  </Link>{' '}
                  to change visibility rules.
                </span>
              )}
            </span>
          ) : (
            'This team has no members, so there are no wishlists to display.'
          )}
        </p>

        <ProtectedContent
          section='roster'
          requirement='admin'
          renderUnauthorized={false}
        >
          <Button
            size='sm'
            variant='outline'
            onClick={() => setAddingMembers(true)}
          >
            {t('dashboard.team.roster.add-members')}
          </Button>
        </ProtectedContent>

        {addingMembers && (
          <AddMemberModal open={addingMembers} setOpen={setAddingMembers} />
        )}
      </AlertDescription>
    </Alert>
  )
}

export default NoMemberWarning
